export const getColRatio = (cols: number, isSingleColumn = false): 1 | 2 | 3 | 4 | 6 | 12 => {
  if (isSingleColumn) {
    return 12;
  }

  if (cols < 5) {
    return (12 / cols) as 1 | 2 | 3 | 4;
  }

  if (cols === 5) {
    return 4;
  }

  return 6;
};

export const getFilteredOneTrustActiveGroups = () => {
  return window?.OnetrustActiveGroups?.split(',')
    ?.filter((value) => !!value && value.startsWith('C'))
    ?.join(',');
};
